export default {
  computed: {
    ExtendFieldSettings1() {
      let Setting = this.getSetting('员工配置:扩展字段1')
      Setting && (Setting.placeholder = this.mixinPlaceholder(Setting))
      return Setting
    },
    ExtendFieldSettings2() {
      let Setting = this.getSetting('员工配置:扩展字段2')
      Setting && (Setting.placeholder = this.mixinPlaceholder(Setting))
      return Setting
    },
    ExtendFieldSettings3() {
      let Setting = this.getSetting('员工配置:扩展字段3')
      Setting && (Setting.placeholder = this.mixinPlaceholder(Setting))
      return Setting
    },
    ExtendFieldSettings4() {
      let Setting = this.getSetting('员工配置:扩展字段4')
      Setting && (Setting.placeholder = this.mixinPlaceholder(Setting))
      return Setting
    },
    ExtendFieldSettings5() {
      let Setting = this.getSetting('员工配置:扩展字段5')
      Setting && (Setting.placeholder = this.mixinPlaceholder(Setting))
      return Setting
    }
  },
  methods: {
    mixinPlaceholder(Setting) {
      return this.$getPlaceholder(Number(Setting.ExtendFieldType), Setting.IsRequiredExtendField)
    },

    mixinShowAlertTips(Setting, alertTips) {
      if (alertTips) {
        Number(Setting.ExtendFieldType) === 0
          ? this.$toast(this.$t('PleaseFill_x', 'function', [Setting.ExtendFieldName]))
          : this.$toast(this.$t('PleaseSelect_x', 'function', [Setting.ExtendFieldName]))
      }
    },

    // 扩展字段校验 返回 true 表示校验不通过
    mixinCheckExtendField(details, alertTips = true) {
      let {ExtendFieldSettings1, ExtendFieldSettings2, ExtendFieldSettings3, ExtendFieldSettings4, ExtendFieldSettings5} = this
      let ExtendField1 = details.ExtendField1
      let ExtendField2 = details.ExtendField2
      let ExtendField3 = details.ExtendField3
      let ExtendField4 = details.ExtendField4
      let ExtendField5 = details.ExtendField5

      if (ExtendFieldSettings1 && ExtendFieldSettings1.IsDisplayExtendField && ExtendFieldSettings1.IsRequiredExtendField && !ExtendField1) {
        this.mixinShowAlertTips(ExtendFieldSettings1, alertTips)
        return true
      }
      if (ExtendFieldSettings2 && ExtendFieldSettings2.IsDisplayExtendField && ExtendFieldSettings2.IsRequiredExtendField && !ExtendField2) {
        this.mixinShowAlertTips(ExtendFieldSettings2, alertTips)
        return true
      }
      if (ExtendFieldSettings3 && ExtendFieldSettings3.IsDisplayExtendField && ExtendFieldSettings3.IsRequiredExtendField && !ExtendField3) {
        this.mixinShowAlertTips(ExtendFieldSettings3, alertTips)
        return true
      }
      if (ExtendFieldSettings4 && ExtendFieldSettings4.IsDisplayExtendField && ExtendFieldSettings4.IsRequiredExtendField && !ExtendField4) {
        this.mixinShowAlertTips(ExtendFieldSettings4, alertTips)
        return true
      }
      if (ExtendFieldSettings5 && ExtendFieldSettings5.IsDisplayExtendField && ExtendFieldSettings5.IsRequiredExtendField && !ExtendField5) {
        this.mixinShowAlertTips(ExtendFieldSettings5, alertTips)
        return true
      }
      return false
    }
  }
}
